module.exports = "img/flags/TC.dea8f01.png";